import { useCallback, useEffect, useState } from 'react';
import { partnerService } from '@/services/partner';
import { PartnerEmail, PartnerEmailsParams } from '@/types/partner';

const isVisiblePartnerClient = (client: PartnerEmail) =>
  client.type !== 'LEGACY';

export function usePartnerClients(params: PartnerEmailsParams & { partnerId: string }) {
  const [clients, setClients] = useState<PartnerEmail[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchClients = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await partnerService.getUsers(params.partnerId, {
        offset: params.offset,
        limit: params.limit,
        q: params.q,
      });
      const visibleClients = (response.data ?? []).filter(isVisiblePartnerClient);
      setClients(visibleClients);
      const hiddenCount = (response.data?.length ?? 0) - visibleClients.length;
      setTotal(Math.max(0, (response.total ?? visibleClients.length) - hiddenCount));
    } catch {
      setError('Erro ao carregar clientes');
      setClients([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [params.partnerId, params.offset, params.limit, params.q]);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  return {
    clients,
    total,
    loading,
    error,
    refetch: fetchClients,
  };
}
